<form [ngClass]="themeClass" (ngSubmit)="updateTime()">
  <div class="header dark-text-color">{{ header }}</div>
  <div class="sub-header light-text-color">Task: {{ title }}</div>

  <div>
    <mat-form-field [floatLabel]="'always'">
      <mat-label>Choose a date (MM/DD/YYYY) </mat-label>
      <input matInput [matDatepicker]="picker" [formControl]="datePicker" />
      <mat-datepicker-toggle
        matIconSuffix
        [for]="picker"
      ></mat-datepicker-toggle>
      <mat-datepicker #picker></mat-datepicker>
    </mat-form-field>
  </div>

  <div>
    <mat-form-field [floatLabel]="'always'">
      <mat-label>Time (HH:MM:SS {{ hour12 ? ' AM/PM' : '' }})</mat-label>
      <input
        matInput
        placeholder="HH:MM:SS {{ hour12 ? ' AM/PM' : '' }}"
        [formControl]="timeControl"
      />
    </mat-form-field>
  </div>

  <button
    mat-raised-button
    color="primary"
    [disabled]="disableSubmit"
    type="submit"
    value="submit"
  >
    Update
  </button>
</form>
